import { Tabs as AntdTabs } from 'antd';
import styled from 'styled-components';

export const Tabs = styled(AntdTabs)`
  .ant-tabs-tab.ant-tabs-tab-disabled {
    color: var(--disabled-color);
  }

  &.deal-room-tabs {
    .ant-tabs-tabpane {
      margin-block: 15px;
    }

    .ant-tabs-nav {
      margin: 0;

      &:before {
        display: none;
      }
    }

    .ant-tabs-nav-list {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: 12px;
      width: 100%;
    }

    .ant-tabs-tab {
      padding: 12px;
      font-weight: 500;
      text-align: center;
      min-width: 120px;
      border-radius: 12px !important;
      background: #f2f3f5 !important;

      .ant-tabs-tab-btn {
        color: #1a295a;
        font-size: 16px;
        line-height: normal;
        white-space: nowrap;
        width: 100%;
        text-align: center;
      }

      &.ant-tabs-tab-active {
        background: #ce6239 !important;

        .ant-tabs-tab-btn {
          color: #fff;
        }
      }
    }
  }

  @media only screen and (max-width: 768px) {
    &.share-deal-room {
      flex-direction: column;
      gap: 15px;
      max-width: 100%;

      &.ant-tabs-left > .ant-tabs-content-holder > .ant-tabs-content > .ant-tabs-tabpane {
        padding-left: 0;
      }

      .ant-tabs-content-holder {
        .ant-form-inline {
          flex-direction: column;
          gap: 15px;
        }
      }
    }
  }
`;
